<template>
  <div
    class="UISearchItem mb-xxs"
    :class="type == 'page' ? 'mb-xs' : ''"
  >
    <div class="flex flex-nowrap">
      <UILinkComponent
        :to="item.url"
        class="link-wrapper flex flex-column"
      >
        <span class="title">{{ item.title || item.url }}</span>
        <span class="subtitle">{{ item.subTitle }}</span>
      </UILinkComponent>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { SearchResult } from '~/types/search'

  defineProps({
    item: {
      type: Object as PropType<SearchResult>,
      required: true,
    },
    noImage: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'page',
    },
  })
</script>

<style lang="scss" scoped>
  .image {
    position: relative;
    width: 6rem;
    margin-right: 2.3rem;
    aspect-ratio: 2/3;

    :deep(.image-wrapper) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 100%;
      }
    }
  }

  .link-wrapper {
    width: 100%;
    color: $white;
    text-decoration: none;

    .title {
      color: $color-text;
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.1;
      margin-bottom: var(--margin-xs);
    }

    .subtitle {
      color: $color-text;
      opacity: 0.6;
      text-transform: inherit;
      @include line-clamp(2);
      overflow: hidden;
    }
  }
</style>
